import { useState, useEffect } from 'react';

export default function useElementDims(ref, optionsArg) {
  let options = {
    onlyOnce: false,
    ...optionsArg,
  };
  const [dims, setDims] = useState(null);

  console.log("ued dims",dims);

  useEffect(() => {

    console.log('$ref', ref);
    const observeTarget = ref.state ?? ref.current;

    let runAgain = true;
    let cleaned = false;
    const resizeObserver = new ResizeObserver((entries) => {
      console.log('ResizeObserver triggered');
      requestAnimationFrame(() => {
        for (let entry of entries) {
          //const { width, height } = entry.contentRect;
          const newDims = observeTarget.getBoundingClientRect();
          if (runAgain) {
            //debugger;
            setDims(newDims);
            runAgain = !options.onlyOnce;
          } else {
            // We only needed to do this once; clean up
            doCleanup(newDims);
          }
        }
      });
    });

    if (observeTarget) {
      resizeObserver.observe(observeTarget);
    }

    function doCleanup(newDims) {
      if (!cleaned) {
        if (observeTarget) {
          resizeObserver.unobserve(observeTarget);
        }
        resizeObserver.disconnect();
      }
      cleaned = true;
    };
    return doCleanup;
  }, 'state' in ref ? [ref.state] : []);
  
  return dims;
}
